// routeUtils.js
import React from 'react';
import { jwtDecode } from 'jwt-decode';
import { additionalRoutes, baseRoutes, clientRoutes } from 'routes/routeConfig';

export const getClientName = () => {
  const domain = window.location.hostname;
  return domain?.split('.')[0].toUpperCase();
};

export const getTenantFromToken = () => {
  const token = localStorage.getItem('auth_tokens');
  // console.log(token, 'dfdfdfdfdffd');
  if (!token) return null;

  // Assuming the token is stored as a JSON string, parse it.
  const parsedToken = JSON.parse(token);

  if (parsedToken && parsedToken.access_token) {
    const decodedToken = jwtDecode(parsedToken.access_token);
    return decodedToken?.tenant_id;
  }
};

export const getTenantDetails = () => {
  const token = localStorage.getItem('auth_tokens');
  if (!token) return null;

  // Assuming the token is stored as a JSON string, parse it.
  const parsedToken = JSON.parse(token);

  if (parsedToken && parsedToken.access_token) {
    const decodedToken = jwtDecode(parsedToken.access_token);
    return decodedToken;
  }
};

export const generateClientRoutes = (clientName, tenantId) => {
  if (!clientName || !tenantId) return [];

  const processRoute = (route, tenantId) => {
    const processedRoute = {
      name: route.name,
      icon: route.icon ? <route.icon /> : null,
      to: `/${tenantId}/${route.path}`,
      active: route.active,
      img: route.img
    };

    // Handle nested children recursively
    if (route.children) {
      processedRoute.children = route.children.map(childRoute =>
        processRoute(childRoute, tenantId)
      );
    }

    return processedRoute;
  };

  // Retrieve nav_items from localStorage
  const navItemsRaw = localStorage.getItem('nav_items');
  let navItems = [];

  try {
    let navItem = navItemsRaw ? JSON.parse(navItemsRaw) : [];
    navItems = [...navItem, { name: 'offlineData' }];
  } catch (error) {
    console.error('Error parsing nav_items from localStorage:', error);
  }

  const routes = [];

  // Check if nav_items is available and has data, otherwise use the base routes
  if (navItems.length > 0) {
    navItems.forEach(item => {
      // Check if item is a string or an object
      if (typeof item === 'string') {
        // Handle simple string case - look up by key
        const route = additionalRoutes[item];
        if (route) {
          routes.push(processRoute(route, tenantId));
        }
      } else if (typeof item === 'object' && item !== null) {
        // Handle object with potential children
        // Use item.name as key to look up in additionalRoutes
        const routeKey = item.name;
        const baseRoute = additionalRoutes[routeKey];

        if (baseRoute) {
          const routeCopy = { ...baseRoute };

          // If the item has children, process them
          if (item.children && Array.isArray(item.children)) {
            routeCopy.children = item.children.map(child => {
              // If child is a string, use it as key to look up in additionalRoutes
              if (typeof child === 'string') {
                return (
                  additionalRoutes[child] || {
                    name: additionalRoutes[child]?.name || child,
                    path: additionalRoutes[child]?.path || child.toLowerCase(),
                    active: true,
                    icon: additionalRoutes[child]?.icon || null
                  }
                );
              }

              // If child is an object with a name, use child.name as key
              if (typeof child === 'object' && child.name) {
                const childKey = child.name;
                const childRoute = additionalRoutes[childKey];

                if (childRoute) {
                  const childRouteCopy = { ...childRoute };

                  // If this child also has children, process them recursively
                  if (child.children && Array.isArray(child.children)) {
                    childRouteCopy.children = child.children.map(grandChild => {
                      if (typeof grandChild === 'string') {
                        return (
                          additionalRoutes[grandChild] || {
                            name:
                              additionalRoutes[grandChild]?.name || grandChild,
                            path:
                              additionalRoutes[grandChild]?.path ||
                              grandChild.toLowerCase(),
                            active: true,
                            icon: additionalRoutes[grandChild]?.icon || null
                          }
                        );
                      }

                      if (typeof grandChild === 'object' && grandChild.name) {
                        return (
                          additionalRoutes[grandChild.name] || {
                            name:
                              additionalRoutes[grandChild.name]?.name ||
                              grandChild.name,
                            path:
                              additionalRoutes[grandChild.name]?.path ||
                              grandChild.name.toLowerCase(),
                            active: true,
                            icon:
                              additionalRoutes[grandChild.name]?.icon || null
                          }
                        );
                      }

                      return {
                        name: 'Unknown',
                        path: '',
                        active: false,
                        icon: null
                      };
                    });
                  }

                  return childRouteCopy;
                }

                // Fallback if child key not found in additionalRoutes
                return {
                  name: childKey,
                  path: childKey.toLowerCase(),
                  active: true,
                  icon: null
                };
              }

              return { name: 'Unknown', path: '', active: false, icon: null };
            });
          }

          routes.push(processRoute(routeCopy, tenantId));
        }
      }
    });
  } else {
    // If no nav_items in localStorage, use baseRoutes and client-specific additional routes
    Object.values(baseRoutes).forEach(route =>
      routes.push(processRoute(route, tenantId))
    );

    const clientConfig = clientRoutes[clientName];
    if (clientConfig) {
      clientConfig.additionalRoutes.forEach(routeKey => {
        const route = additionalRoutes[routeKey];
        if (route) {
          routes.push(processRoute(route, tenantId));
        }
      });
    }
  }

  return [
    {
      label: '',
      labelDisable: false,
      children: routes
    }
  ];
};
